<div class="notif-panel d-flex flex-column" [ngClass]="{'mobile-view': isHandset$ | async}" *ngIf="showNotifications">

    <!-- Header -->
    <div class="notif-header flex-shrink-0">
        <div class="notif-header__left">
            <span class="notif-header__title">Notifications</span>
            <span class="notif-badge" *ngIf="notifications?.length > 0">{{ notifications.length }}</span>
        </div>
        <button mat-icon-button class="notif-close-btn" (click)="closeNotificationFn()">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <!-- List -->
    <div class="notif-body flex-grow-1 overflow-hidden">
        <div class="h-100 overflow-y-auto custom-scrollbar">

            <!-- Empty state -->
            <div *ngIf="!notifications?.length" class="notif-empty">
                <mat-icon class="notif-empty__icon">notifications_none</mat-icon>
                <p class="notif-empty__text">No notifications</p>
            </div>

            <!-- Notification items -->
            <div *ngFor="let n of notifications; let i = index"
                class="notif-item"
                [ngClass]="getItemClass(n.notificationType)">

                <!-- Icon badge -->
                <div class="notif-item__icon-wrap" [ngClass]="getIconClass(n.notificationType)">
                    <mat-icon class="notif-item__icon">{{ getIcon(n.notificationType) }}</mat-icon>
                </div>

                <!-- Content -->
                <div class="notif-item__content">
                    <p class="notif-item__message">{{ n.message }}</p>
                    <mat-progress-bar
                        *ngIf="n.notificationType === notificationTypeEnum.GenerationRequestSubmited"
                        mode="determinate"
                        [value]="n.progressPercentage"
                        class="notif-item__progress">
                    </mat-progress-bar>
                    <span class="notif-item__date">{{ n.notificationDate | dateAsAgo }}</span>
                </div>

                <!-- Dismiss -->
                <button mat-icon-button class="notif-item__dismiss" (click)="removeNotification(n.notificationId)" matTooltip="Dismiss">
                    <mat-icon>close</mat-icon>
                </button>

            </div>
        </div>
    </div>

    <!-- Footer -->
    <div class="notif-footer flex-shrink-0" *ngIf="notifications?.length > 0">
        <button mat-button class="notif-clear-btn" (click)="removeAllNotifications()">
            <mat-icon>delete_sweep</mat-icon>
            Clear all
        </button>
    </div>

</div>
